export const camelCase = /^[a-z]*([A-Z]+[a-z]*)*$/;
export const kebabCase = /^[a-z]+((-[a-z]+)*)*$/;
export const snakeCase = /^[a-z]+((_[a-z]+)*)*$/;

const selectStartOfWordsInCamelCase = /([A-Z]+(?![a-z])|[A-Z](?=[a-z]))/g;

export const camelCaseToSnakeCase = (
  ...camelCaseStrings: (string | undefined)[]
): string =>
  camelCaseStrings
    .map((camelCaseString: string | undefined): string =>
      (camelCaseString ?? '').replace(
        selectStartOfWordsInCamelCase,
        (firstLetterOfWords: string): string => {
          return `_${firstLetterOfWords.toLowerCase()}`;
        },
      ),
    )
    .join('_')
    .replace(/(^_+)/g, '')
    .replace(/(_+)/g, '_');

export const camelCaseToKebabCase = (
  ...camelCaseStrings: (string | undefined)[]
): string =>
  camelCaseStrings
    .map((camelCaseString: string | undefined): string =>
      (camelCaseString ?? '').replace(
        selectStartOfWordsInCamelCase,
        (firstLetterOfWords: string): string => {
          return `-${firstLetterOfWords.toLowerCase()}`;
        },
      ),
    )
    .join('-')
    .replace(/(^-+)/g, '')
    .replace(/(-+)/g, '-');
